<div class="p-g-12 p-lg-12 p-md-12">
  <div class="form-field p-g-12 p-md-12 p-lg-12">
    <div class="form-label">
      <label for="quotationamount" translate>label_reply</label>
    </div>
    <div class="form-control">
      <textarea type="text" pInputText [(ngModel)]="replyText" type="text" pInputText>
      </textarea>
    </div>
  </div>

  <div class="form-buttons p-g-12">
    <button pButton type="button" label="Reply" icon="fa fa-reply" (click)="doRply()"></button>
    <button class="negative-button" pButton type="button" icon="fa fa-close" label="Cancel" (click)="cancel()"></button>
  </div>
</div>
